module.exports = __webpack_public_path__ + "static/media/icon-search.c9e8f43d.svg";